import React from 'react';
import { Block } from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';
import i18next from '../../../config/i18next';
import FooterSocialLinks from '../FooterSocialLinks';
import { CONTACT_INFORMATION_BLOCK_ID } from '../../../config/constants';

import './style.scss';


const FooterSocialMenu = () => {
  return (
    <div className={`FooterSocialMenu col-sm-12 ${config.get('CURRENT_DOMAIN') === 'kp' ? '' : 'col-md-6'}`}>

      {/* @FIXME refactor and move this to footer menu. */}
      <h4>{ i18next.t('footer_contact_information') }</h4>
      <Block id={CONTACT_INFORMATION_BLOCK_ID} />
      <FooterSocialLinks />
    </div>
  );
};

export default FooterSocialMenu;
